<template>
  <div class="chart-container" style="position: relative; height: 100%; width: 100%;">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'ChartJsWidget',
  props: {
    type: {
      type: String,
      required: true,
      default: 'bar'
    },
    data: {
      type: Object,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      chartInstance: null
    }
  },
  mounted() {
    this.renderChart()
  },
  watch: {
    data: {
      handler() {
        this.updateChart()
      },
      deep: true
    },
    type() {
      this.destroyChart()
      this.renderChart()
    }
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    renderChart() {
      if (!this.$refs.chartCanvas) return
      
      const ctx = this.$refs.chartCanvas.getContext('2d')
      this.chartInstance = new Chart(ctx, {
        type: this.type,
        data: this.data,
        options: {
          responsive: true,
          maintainAspectRatio: false,
          ...this.options
        }
      })
    },
    updateChart() {
      if (this.chartInstance) {
        this.chartInstance.data = this.data
        this.chartInstance.update()
      } else {
        this.renderChart()
      }
    },
    destroyChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy()
        this.chartInstance = null
      }
    }
  }
}
</script>
